<template>
  <div class="product">
    <tips class="product-tip">
      <div class="product-tip__line"> 1. 注意“产品与商品”的区别; 可简单理解为: "已归属到某个平台或独立站贴标销售的为商品"，"等待归属到某个平台或独立站未贴标销售的为产品"；产品为商品的前置状态，因此请注意“产品储备库存与商品库存量”的区别；如需要可使用该目录进行管理； </div>
      <div class="product-tip__line"> 2. 由于考虑到会员可能在亚马逊平台销售以外,还可能在其它跨境电商平台,独立站或其它渠道销售.为更好地进行库存管理,特设立此"产品储备库存量"的分目录,详细列出还没归属销售到某个平台或独立站或其它渠道的产品库存数量(即还没贴标的产品库存)； </div>
    </tips>
    <div class="product-top">
      <div class="product-top__name">产品储备库存量</div>
      <div class="product-top__fun">
        <div class="product-top-item">
          <div class="product-top-item__name">国家站点:</div>
          <el-select size="mini"></el-select>
        </div>
        <div class="product-top-item product-top-item--input">
          <el-input size="mini" placeholder="请输入产品名称,型号等"></el-input>
        </div>
        <div class="product-top__btn">搜索</div>
        <div class="product-top__btn">创建盘点单</div>
      </div>
    </div>
    <div class="product-table">
      <Table :head="TableHead" height="550" width="1654"></Table>
    </div>
  </div>
</template>

<script>
import { StockStatusSearchData, StockStatusNewMoodule } from './class'
import Table from 'components/common/Table.vue'
import tips from '../common/tips.vue';
export default {
  name: 'productReserveInventory',
  components: {
    Table, tips
  },
  data(){
    return {
      searchData: new StockStatusSearchData(),
      TableHead: StockStatusNewMoodule.NEWPRODUCTTABLEHEAD()
    }
  }
}
</script>

<style lang="scss" scoped>
.product{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__name{
      font-weight: bold;
      font-size: 16px;
      color: black;
    }
    &__fun{
      display: flex;
    }
    &-item{
      display: flex;
      align-items: center;
      margin-left: 10px;
      ::v-deep{
        .el-input__inner{
          width: 100px;
        }
      }
      &__name{
        font-size: 14px;
        margin-right: 5px;
      }
      &--input{
        ::v-deep{
          .el-input__inner{
            width: 250px;
          }
        }
      }
    }
    &__btn{
      line-height: 30px;
      padding: 0 15px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
